module.exports = __webpack_public_path__ + "static/media/taffiethule11.cdcfe964.jpg";